var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[(!_vm.restore)?_c('AuthForm'):_vm._e(),(_vm.restore)?_c('RestoreForm'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }